import { generateGradient } from '../Utilities/Helpers';

import '../Styles/Legend.css';

export default function Legend(props) {
	const { show, language } = props;

	return (
		<div className={show ? 'legend-window-wrapper show': 'legend-window-wrapper'}>
			<div className='legend-window'>
			{/* <div className={show ? 'legend-window show': 'legend-window'}> */}
				{/* <div className="button-close" onClick={onToggle}></div> */}
				<div className="legend-title">{(language) ? language['legend:title'] : 'Level'}</div>
				<div className="content">
					{/* <div className="legend-wrapper">
						{layerList()}
					</div> */}
					<div className="legend-gradient" style={{background: generateGradient()}}></div>
					<div className="legend-labels-wrapper">
						<div className="legend-label low">{(language) ? language['legend:low'] : 'Low'}</div>
						<div className="legend-label high">{(language) ? language['legend:high'] : 'High'}</div>
						<div className="legend-label extreme">{(language) ? language['legend:extreme'] : 'Extreme'}</div>
					</div>
				</div>
			</div>
		</div>
	);
}